import type { Param, Values } from './types';

/** Modifiers every engine understands. They rewrite the query text. */
export const GLOBAL_PARAMS: Param[] = [
  {
    id: 'exact',
    type: 'flag',
    token: 'x',
    aliases: ['exact', 'quote'],
    label: 'Exact phrase',
    help: 'Wraps the whole query in quotes.',
    group: 'Query',
  },
];

// `site:x`, `-exclude`-style operator words stay outside the quotes, or the
// engine would search for them literally.
// `-40` is a number, not an exclusion.
const OPERATOR = /^(-(?!\d)|[a-z_]+:)\S/i;

const WORDS = /(?:-|[a-z_]+:)?"[^"]*"|\S+/gi;

/** Just the operator words (`site:x`, `-word`, `stars:>100`) of a query. */
export function operatorWords(query: string): string {
  return (query.match(WORDS) ?? []).filter(w => OPERATOR.test(w)).join(' ');
}

export function applyGlobals(query: string, values: Values): string {
  const q = query.trim();
  if (values.exact !== true || !q || /^"[^"]*"$/.test(q)) return q;
  // Quoted operator values (intitle:"two words") stay one word.
  const words = q.match(WORDS) ?? [];
  const operators = words.filter(w => OPERATOR.test(w));
  const phrase = words
    .filter(w => !OPERATOR.test(w))
    .join(' ')
    .replaceAll('"', '');
  return [phrase && `"${phrase}"`, ...operators].filter(Boolean).join(' ');
}
